// src/shared/config/api.ts
/**
 * API ベースURLの解決とURLユーティリティ
 */

const pickFirstNonEmpty = (...candidates: Array<string | undefined>): string => {
  for (const v of candidates) {
    if (typeof v === 'string' && v.trim().length > 0) {
      return v.trim()
    }
  }
  return ''
}

/** JIZAIPAD API ベースURL（末尾スラッシュは除去） */
export const API_BASE_URL: string = (() => {
  const raw = pickFirstNonEmpty(
    process.env.JIZAIPAD_API_URL
  )
  return raw.replace(/\/$/, '')
})()

/** /v1/tenants/{tenantId} */
export const tenantPath = (tenantId: string): string => `/v1/tenants/${tenantId}`

/** ベースURL + パスの連結（スラッシュ重複なし） */
export const apiUrl = (...parts: string[]): string => `${API_BASE_URL}${parts.join('')}`
